import Blogs from "./Blogs";

function Home() {
  return (
    <main>
      <Blogs/>
    </main>
  );
}

export default Home;
